var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "action_rule" }, [
    !_vm.is_catalog
      ? _c(
          "div",
          { staticClass: "discount_type" },
          [
            _c("yes_no", {
              key: "DISCOUNT_TYPE",
              attrs: {
                title: "DISCOUNT_TYPE",
                radio_options: _vm.radio_options,
              },
              model: {
                value: _vm.discount_type,
                callback: function ($$v) {
                  _vm.discount_type = $$v
                },
                expression: "discount_type",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.is_catalog
      ? _c("div", { staticClass: "discount_rule" }, [
          _vm.is_simple
            ? _c(
                "div",
                { staticClass: "simple_val" },
                [
                  _c("info_field", {
                    attrs: {
                      f_uniq: "ct",
                      f_type: "discount_val",
                      is_disabled: false,
                      f_title: _vm.__t("PWA.DISCOUNT_VAL"),
                      f_val: _vm.cur_item.discount_val,
                    },
                    on: { update_categ: _vm.change_atr },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "products_list mt-4" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                      on: { click: _vm.add_prod },
                    },
                    [
                      _c("span", { staticClass: "fal fa-eject mr-1" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.__t("ADD")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.gift_blocks, function (block) {
                    return _c("action_params_gift", {
                      key: block.id,
                      attrs: { block: block, is_catalog: _vm.is_catalog },
                      on: {
                        update: _vm.update_block,
                        remove: function ($event) {
                          return _vm.remove_block(block.id)
                        },
                      },
                    })
                  }),
                ],
                2
              ),
        ])
      : _c(
          "div",
          { staticClass: "products_list mt-4" },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                on: { click: _vm.add_prod },
              },
              [
                _c("span", { staticClass: "fal fa-eject mr-1" }),
                _vm._v(
                  "\n            " + _vm._s(_vm.__t("ADD")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.gift_blocks, function (block) {
              return _c("action_params_gift", {
                key: block.id,
                attrs: { block: block, is_catalog: _vm.is_catalog },
                on: {
                  update: _vm.update_block,
                  remove: function ($event) {
                    return _vm.remove_block(block.id)
                  },
                },
              })
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }